<template>
  <Section :title="$t('tasks.description')" :border="true">
    <template #actions>
      <Button btn-class="btn-sm" type="new"  btn-text="label.editDesc"  @click.prevent="updateData"/>
    </template>
    <div v-if="update">
      <form id="kt_modal_form_project" @submit.prevent="updateDescription" class="form mt-5" >
        <CKEditor
            id="desc-editor"
            :content="desc"
            @text="getDesc"
        />
        <div class="d-flex mt-5 flex-row-reverse">
          <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="updateData"></Button>
          <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="loading" ></Button>
        </div>
      </form>
    </div>
    <div v-if="!update">
      <div class=" min-h-100px back" v-html="task.description"></div>
    </div>

  </Section>
</template>
<script setup>
import Button from '@/components/Button.vue';
import CKEditor from '@/components/CKEditor.vue';
import { ref } from 'vue';
import { onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Section from "@/Modules/Projects/components/Section.vue";


const props = defineProps({
    task: {type: Object, default: {}}
})

const store = useStore()
const route = useRoute()
const emit = defineEmits(['load'])

const update = ref(false)
const loading = ref(false)
const desc = ref("")

watch(() => props.task, () => {
    desc.value = props.task?.description ? props.task?.description : ''
})

const updateData = () => { update.value = !update.value}

const getDesc = (text) => {
    desc.value = text
}

const updateDescription = async () => {
    loading.value = true
    try{
      await store.dispatch('tasks/updateTask', {
        id:props.task?.id,
        title: props.task?.title,
        project_id: props.task?.project_id,
        milestone_category_id: props.task?.milestone_category_id,
        task_status_id: props.task?.task_status_id || props.task?.taskStatus?.id,
        task_priority_id: props.task?.task_priority_id,
        project_category_step_id: props.task?.project_category_step_id,
        description: desc.value,
        users: props.task?.users?.map(el => el?.id)
      })      
      loading.value = false
      update.value = false
      emit("load")
    }catch(err){

    }
}

onMounted(() => {
  if(props.task?.description) {
    desc.value = props.task?.description
  }
})

</script>
<style>
.back{
    background-color: var(--bs-light-primary);
    border-radius: 8px;
  padding: 10px;
  width: auto;
}
</style>